import { FontLineHeightNormal } from 'autogen/design-tokens/global/tokens';
import { css } from 'styled-components';
import { IBody } from '../components/Body';

const BodyStylling = css<{ $strong: IBody['strong'] }>`
     line-height: ${FontLineHeightNormal};
     font-family: ${({ theme}) => theme.TypographyFamilyPrimary};
     font-weight: ${({$strong, theme}) => $strong ? theme.TypographyBodyWeightStrong: theme.TypographyBodyWeightDefault};
`;

export default BodyStylling

